import { render, staticRenderFns } from "./SancionShow.vue?vue&type=template&id=11c46213&scoped=true&"
import script from "./SancionShow.vue?vue&type=script&lang=ts&"
export * from "./SancionShow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c46213",
  null
  
)

export default component.exports